import { Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { URLS } from '../shared/url';
import { Observable } from '../../../node_modules/rxjs';
import { RatingGridViewModel, RatingViewModel } from '../models/generated-view-models';
import { ResponseTypeEnum } from '../models/enums';

@Injectable({
    providedIn: 'root'
})
export class RatingService {

    constructor(private http: BaseHttpService) { }

    public getRatingList = (): Observable<RatingGridViewModel[]> =>{
        return this.http.Get(URLS.getRatingList);
    }

    public getRating = (ratingId: number): Observable<RatingViewModel> => {
        return this.http.Get(`${URLS.getRating}/${ratingId}`);
    }

    public saveRating = (rating: RatingViewModel): Observable<boolean> => {
        return this.http.Post(URLS.saveRating, rating, ResponseTypeEnum.Success);
    }

    public deleteRating = (ratingId: number): Observable<boolean> => {
        return this.http.Delete(`${URLS.deleteRating}/${ratingId}`, ResponseTypeEnum.Success);
    }

}
